import React, { useState } from 'react';
import {
  ExportVendorOffersReport,
  ExportVendorClientTrackingReportAPI,
} from "../../../../../../Services";
import { GetApp } from '@material-ui/icons';
import { showError, showSuccess, showWarn } from '../../../../../../Helper';
import { useTranslation } from 'react-i18next';
import { VendorsTranslationPath } from '../../../I18n/VendorsLocale';
import { SplitButton } from '../../../../../../Components/SliptButton/SplitButton';

const options = [
  { label: 'Excel', value: 1 },
  { label: 'PDF', value: 2 },
  { label: 'CSV', value: 3 },
];

export default function ExportButton({ filter }) {
  const { t } = useTranslation(VendorsTranslationPath);
  const [selectedIndex, setSelectedIndex] = useState(1);

  const handleClick = async () => {

    if (!filter.totalCount) {
      showWarn(
        t("no_data_available_for_export", undefined, {
          autoDismissTimeout: 10000,
        })
      );
      return;
    }
   
    try {
      if (filter?.isClientTracking) {
        await ExportVendorClientTrackingReportAPI(filter, selectedIndex);
      } else await ExportVendorOffersReport(filter, selectedIndex);
      showSuccess(
        t("exported_successfully", undefined, { autoDismissTimeout: 10000 })
      );
    } catch (error) {
      showError(t("something_went_wrong"));
    }
  };

  return (
    <SplitButton
      onClick={handleClick}
      options={options}
      optionNameKey='label'
      optionValueKey='value'
      icon={<GetApp />}
      onOptionSelect={(option) => setSelectedIndex(option.value)}
    />
  );
}
